/* src/app/shared/components/controls/autocomplete/autocomplete.component.scss */
:host {
  display: block;
  width: 100%;
}
.autocomplete-field {
  width: 100%;
}
.clear-icon {
  color: var(--primary-light);
  position: absolute;
  font-size: 14px;
  right: 4px;
  top: 2px;
  transform: rotate(45deg);
  cursor: pointer;
  z-index: 1;
}
.clear-icon:hover {
  color: var(--primary);
  transition: 0.1s ease-in;
}
.input {
  border-bottom: var(--primary) solid 1px;
  margin-top: 1px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  padding-right: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .autocomplete-options-panel {
  background-color: var(--white-color);
}
/*# sourceMappingURL=autocomplete.component-BGVOB5UT.css.map */
